import * as React from "react"

type ContainerProps = {
  children: any
  className?: string
  extraProps?: any
  size: 'xs' | 's' | 'm' | 'l'
  gutter: boolean
}

export const Container = (p: ContainerProps) => {
  const containerMod = `container--${p.size}${p.gutter ? 'g' : ''}`
  return <div className={`container-fluid ${containerMod} align--center ${p.className ? p.className : ''}`} {...p.extraProps}>{p.children}</div>
}

Container.defaultProps = {
  size: 'm',
  gutter: false
}

export const Row: React.StatelessComponent = ({ children }) => <div className="row">{children}</div>

export const Block: React.StatelessComponent = ({ children }) => <div className="page-block">{children}</div>
